let ReturnRefund = {
  DEFECTED_PRODUCT: 1,
  INCORRECT_PRODUCT: 2
}

export { ReturnRefund }
